/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exception_Notes_LabelInputs */

const en_exception_notes_label = /** @type {(inputs: Exception_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes for the service desk (optional)`)
};

const ja_exception_notes_label = /** @type {(inputs: Exception_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスデスクへのメモ（任意）`)
};

const fr_exception_notes_label = /** @type {(inputs: Exception_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes pour le service desk (optionnel)`)
};

const de_exception_notes_label = /** @type {(inputs: Exception_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen für den Service Desk (optional)`)
};

/**
* | output |
* | --- |
* | "Notes for the service desk (optional)" |
*
* @param {Exception_Notes_LabelInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const exception_notes_label = /** @type {((inputs?: Exception_Notes_LabelInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exception_Notes_LabelInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exception_notes_label(inputs)
	if (locale === "ja") return ja_exception_notes_label(inputs)
	if (locale === "fr") return fr_exception_notes_label(inputs)
	return de_exception_notes_label(inputs)
});